<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="4" :xs="24">
        <div>
          <el-menu default-active="999">
            <el-menu-item @click="fetchFiles" index="999">
              <span slot="title">全部</span>
            </el-menu-item>
            <el-menu-item
                v-for="item in typeOptions"
                :key="item.id"
                :index="item.id"
                @click="filterByCategory(item.type)"
            >
              <span slot="title">{{ item.type }}</span>
            </el-menu-item>
          </el-menu>
        </div>
      </el-col>
      <el-col :span="20" :xs="24">
        <div v-if="hasAddPermission" style="margin: 20px">
          <el-button type="primary" @click="openUploadDialog">上传文件到服务器</el-button>
        </div>
        <div>
          <h1 style="text-align: center" @click="fetchFiles">审读报告</h1>
          <el-table
              v-loading="loading"
              :data="paginatedFiles"
              :default-sort="{ prop: 'createDate', order: 'descending' }"
              @sort-change="handleSortChange"
          >
            <el-table-column label="文件名" align="center" prop="fileName" />
            <el-table-column label="上传时间" align="center" prop="createDate" sortable />
            <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
              <template slot-scope="scope">
                <el-button
                    size="mini"
                    type="text"
                    icon="el-icon-download"
                    @click="handleDownload(scope.row)"
                >
                  下载
                </el-button>
                <el-button
                    v-if="hasDelPermission"
                    size="mini"
                    type="text"
                    icon="el-icon-delete"
                    @click="handleDelete(scope.row)"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              :current-page="currentPage"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="filteredFiles.length"
          />
        </div>
      </el-col>
    </el-row>
    <el-dialog title="上传文件" :visible.sync="uploadDialogVisible">
      <input type="file" @change="onFileChange" ref="fileInput" />
      <el-select v-model="selectedCategory" placeholder="请选择分类">
        <el-option v-for="option in typeOptions" :key="option.id" :label="option.type" :value="option.type" />
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="uploadFile">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';

export default {
  name: 'Check',
  data() {
    return {
      selectedFile: null,
      files: [],
      filteredFiles: [],
      paginatedFiles: [],
      loading: false,
      uploadDialogVisible: false,
      selectedCategory: null,
      typeOptions: [
        { id: 1, type: '大平台每周审核' },
        { id: 2, type: '集团新媒体每周审核' },
        { id: 3, type: '重点稿件传播报告' },
        { id: 4, type: '重点账号评论区巡查巡检' },
        { id: 5, type: '大众号巡查巡检' },
      ],
      currentPage: 1,
      pageSize: 10,
      sortProp: 'createDate',
      sortOrder: 'descending',
    };
  },
  created() {
    this.fetchFiles();
  },
  computed: {
    ...mapState({
      user: state => state.user,
    }),
    hasAddPermission() {
      return this.user.funcKeys.includes('data_analysis_business_number_prompt_add');
    },
    hasDelPermission() {
      return this.user.funcKeys.includes('data_analysis_business_number_prompt_del');
    },
    hasUpdatePermission() {
      return this.user.funcKeys.includes('data_analysis_business_number_prompt_update');
    },
  },
  methods: {
    fetchFiles() {
      this.loading = true;
      axios.get('/api/file/getList')
          .then(response => {
            this.files = response.data;
            this.filteredFiles = this.files;
            this.sortAndPaginateFiles();
            this.loading = false;
          })
          .catch(error => {
            console.error('文件列表获取失败:', error);
          });
    },
    filterByCategory(type) {
      this.filteredFiles = this.files.filter(file => file.type === type);
      this.sortAndPaginateFiles();
    },
    openUploadDialog() {
      this.uploadDialogVisible = true;
    },
    onFileChange(event) {
      this.selectedFile = event.target.files[0];
    },
    cancel() {
      this.resetUploadDialog();
    },
    async uploadFile() {
      if (!this.selectedFile) {
        this.$alert('请选择一个文件', '提示', { type: 'warning' });
        return;
      }
      const duplicateFile = this.files.find(file => file.fileName === this.selectedFile.name);
      if (duplicateFile) {
        this.$alert('文件已存在，请选择不同的文件', '提示', { type: 'warning' });
        this.selectedFile = null;
        return;
      }
      const formData = new FormData();
      formData.append('file', this.selectedFile);
      formData.append('type', this.selectedCategory);
      try {
        await axios.post('/api/file/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        this.$alert('文件上传成功', '提示', { type: 'success' });
        this.fetchFiles();
        this.resetUploadDialog();
      } catch (error) {
        console.error('文件上传失败:', error);
        this.$alert('文件上传失败', '提示', { type: 'error' });
        this.resetUploadDialog();
      }
    },
    handleDelete(row) {
      this.$confirm('是否确定删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
          .then(() => {
            axios.delete(`/api/file/delete/${row.id}`)
                .then(response => {
                  this.$alert(response.data.message, '提示', { type: 'success' });
                  this.fetchFiles();
                })
                .catch(error => {
                  console.error('文件删除失败:', error);
                  this.$alert('文件删除失败', '提示', { type: 'error' });
                });
          }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        });
      });
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.sortAndPaginateFiles();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.sortAndPaginateFiles();
    },
    handleSortChange({ prop, order }) {
      this.sortProp = prop;
      this.sortOrder = order;
      this.sortAndPaginateFiles();
    },
    sortAndPaginateFiles() {
      const sortedFiles = [...this.filteredFiles].sort((a, b) => {
        const orderFactor = this.sortOrder === 'ascending' ? 1 : -1;
        if (a[this.sortProp] < b[this.sortProp]) return -orderFactor;
        if (a[this.sortProp] > b[this.sortProp]) return orderFactor;
        return 0;
      });

      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      this.paginatedFiles = sortedFiles.slice(startIndex, endIndex);
    },
    resetUploadDialog() {
      this.uploadDialogVisible = false;
      this.selectedCategory = null;
      this.selectedFile = null;
      this.$refs.fileInput.value = null; // Reset the file input
    },
    handleDownload(row) {
      axios({
        url: `/api/file/download/${row.id}`,
        method: 'GET',
        responseType: 'blob', // 设置响应类型为 blob
      })
          .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', row.fileName); // 设置下载文件名
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url); // 释放 URL 对象
          })
          .catch(error => {
            console.error('文件下载失败:', error);
            this.$alert('文件下载失败', '提示', { type: 'error' });
          });
    },
  },
};
</script>

<style scoped>
.el-table .fixed-width {
  width: 150px;
}
</style>
